import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import Grid from '@material-ui/core/Grid';
import { reduxForm, getFormValues } from 'redux-form';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import CardContent from '@material-ui/core/CardContent';
import UserHeader from '../../organisms/UserHeader';
import m from 'moment';
import CircularProgress from '@material-ui/core/CircularProgress';
import * as common from '../../common';
import axios from 'axios';
import conf from '../../../config/config.js';

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    padding: '0 4px 16px 4px',
    backgroundColor: '#fafafa',
    width: '100%',
    marginLeft: 'auto',
    marginRight: 'auto',   
  },
  buttonS: {
    width: "60%",
    height: "40px",
    margin: "0 10px 0 20px"
  },
  typography:{
    margin: '0 25px 0 25px'
  },
  typography2:{
    margin: '30px 10px 0 10px'
  },
  typography3:{
    margin: '10px 10px -10px 16px'
  },
  typographyImg:{
    margin: '10px 10px 0 16px'
  },
  typographyDescription:{
    lineHeight: "1.3em"
  },
  textFieldL: {
    margin: '10px 10px 5px 10px',
  },
  textFieldS: {
    margin: '10px 10px 5px 10px',
    width: '55%'
  },
  textFieldS3: {
    margin: '10px 10px 5px 10px',
    width: '200px'
  },
  textFieldDate: {
    margin: '10px 10px 5px 10px',
    width: '40%',
    minWidth: '240px',
  },
  fields4: {
    margin: '0px 10px 15px 10px',
    width: '250px',
  },
  button: {
    width: '100%',
  },
  formControl: {
    margin: '10px 20px 10px 20px',
  },
  formLabel: {
    color: "#212121",
    margin: "0 0 5px -5px"
  },
  dateMark: {
    marginTop: "22px",
    fontSize: "1.2em"
  },
  cardimage: {
    width: '100%',
    fontSize: "0.9em",
  },
  media: {
    width: '100%',
  },
  cardContent: {
    textAlign: 'left',
    padding: "2px 8px 0px 8px",
    "&:last-child": {
      paddingBottom: "10px"
    }
  },
  circle: {
    textAlign: 'center'
  },
  container1: {
    fontSize: "0.5em",
    margin: "40px 0 0 1px",
    width: '10px',
  },
  label2: {
    padding: '0 0 0 10px',
    width: '100%',
  },
  typographyWarn: {
    color: "#ffffff",
    backgroundColor: "#e60033",
    borderRadius: '99px',
    border: "solid 1px #e60033",
    margin: '10px 10px 0 10px',
    padding: '7px 4px 4px 8px',
    fontSize: "0.8em",
  }, 
  formLabel2: {
    color: "#212121",
    width: '30px',
  },   
  containerGridItem: {
    margin: "0 0 0 0",
    marginRight: "0",
    padding: '0',
  },
  fields3: {
    display: 'flex',
    flexDirection: 'column',
    padding: '0 4px 16px 4px',
    margin: '0',
  },  
});

const RadioB = withStyles(theme => ({
  root: {
    padding: "0px 5px 0px 10px",
    '&$checked': {
      color: '#1976d2'
    }
  },
  checked: {
    },
}))(Radio);

const Check = withStyles(theme => ({
  root: {
    padding: "0px 5px 0px 10px",
    '&$checked': {
      color: '#1976d2'
    }
  },
  checked: {
    },
}))(Checkbox);

var attachmentFiles = [];

class WorkConsider extends React.Component {

  // 添付資料ダウンロード
  onDownloadFile = async(e) => {
    e.preventDefault();
    const { auth, applyDetail, doOpenDialog } = this.props;
    console.log('start onDownloadFile');
    
    let TargetFileName = "資料_" + e.currentTarget.text;
    let ParentId = '';
    let FileName = '';
    let FilePass = '';
    let FileType = '2';

    applyDetail.data.Attachment.map(function(item) {
      if (TargetFileName === item.Name) {
        FileName = item.Name;
        FilePass = item.Body;
      }
      return null;
    });
    
    let browser = common.browser();
    let childWindow;
    let childWindowName = FileName + ("00000" + Math.floor(Math.random() * 100000)).slice(-5);
    console.log('childWindowName:' + childWindowName);
    // Safariポップアップ抑止対策
    if (browser === 'IOS_SAFARI' || browser === 'MAC_SAFARI') {
      childWindow = window.open('', childWindowName);
    }

    try {
      const ret = await axios.post(conf.API_URL + "GetAttachedFile/getContentDocument",
                        { ParentId, FileName, FilePass, FileType }, {
                        headers: {
                          Authorization: auth.loginInfo.idToken,
                        }
      });
      var pos = FileName.indexOf(".");
      var filetype = "";
      var apptype = ""; 
      filetype = FileName.slice(pos);
      console.log("拡張子= " + filetype);
      apptype = "application/pdf";
      if(filetype === ".png"){
        apptype = 'image/png';
       }
       else if(filetype === ".gif"){
        apptype = 'image/gif';   
       }
       else if(filetype === ".jpg" || filetype === ".jpeg"){
        apptype = 'image/jpeg';
       }
      console.log("apptype= " + apptype); 
      const blob = common.base64toBlob(ret.data.body.data.attachmentFileBody, apptype);
      window.URL = window.URL || window.webkitURL;
      const url = window.URL.createObjectURL(blob);
      childWindow = window.open(url, childWindowName);
      setTimeout(()=>{
        childWindow.document.title = FileName.replace("資料_", "");
      }, 100);
    }catch(e){
      console.log("error 添付資料ダウンロード失敗 " + e.message);
      if (childWindow) childWindow.close();
      const dialog = {
        type: 'ok', // 閉じるのみ表示
        title: '',
        message: 'workConsideration.dialog.error.DLfile',
      };
      doOpenDialog(dialog);
    }
    console.log('end onDownloadFile');
  }

  // お見積金額確認
  onClickEstimateConfirm = () => {
    this.props.history.push('/workEstimateConfirm');
  };

  // ご請求金額確認
  onClickBillConfirm = () => {
    this.props.history.push('/workBillConfirm');
  };

  // 承諾ボタンクリック
  onClickConsent = () => {
    const { doOpenDialog } = this.props;
    const dialog = {
      type: 'okcancel', // 「確認」と「キャンセル」を表示
      title: '',
      message: 'workConsideration.dialog.inquiry',
      action: this.doAction
    };
    doOpenDialog(dialog);
  }

  // 承諾処理実行
  doAction = async() => {

    const { doApplyConsentOperation, doOpenDialog } = this.props;
    try {
      const result = await doApplyConsentOperation();
      console.log(result);
      if (result === '00000') {
        // 正常
        const dialog = {
          type: 'ok', // '閉じる'のみ表示
          title: '',
          message: 'workConsideration.dialog.finish',
          action: this.onClickBack
        };
        doOpenDialog(dialog);
      }
      else if (result === '20800') {
        // 取付申込承諾失敗
        const dialog = {
          type: 'close', // '閉じる'のみ表示
          title: '',
          message: 'workConsideration.dialog.error.failure2',
          action: this.onClickBack
        };
        doOpenDialog(dialog);
      }
      else {
        // その他エラー
        const dialog = {
          type: 'error', // '閉じる'のみ表示
          title: 'system.message.error.title',
          message: 'system.message.error.context',
        };
        doOpenDialog(dialog);
      }
    }
    catch (err) {
      console.log(`エラー: ${err}`);
      // その他エラー
      const dialog = {
        type: 'error', // '閉じる'のみ表示
        title: 'system.message.error.title',
        message: 'system.message.error.title',
      };
      doOpenDialog(dialog);
    }
  };

  // 問合せ/写真追加
  onClickInquiry = () => {
    this.props.history.push('/workInquiry');
  };

  // 撤去確認
  onClickRemoval = () => {
    this.props.history.push('/workRemoval');
  };

  // 戻る
  onClickBack = () => {
    this.props.history.push('/workMenu');
  };

  // 最新化処理実行
  onClickRequest = async() => {
    console.log("最新化ボタンクリック");
    const { getApplyDetailOperation, doOpenDialog, applyDetail, getFinalImageOperation, clearFinalImage } = this.props;
    try {
      const result = await getApplyDetailOperation();
      console.log(result);
      if (result === '00000') {
        clearFinalImage(); // 最終画像クリア
        // 正常の場合は画像読込
        applyDetail.data.ImageDatas.map( ( item, index ) => {
          let ret = "";
          try {
            ret = getFinalImageOperation(item.ImageId, item.ObjectType, item.Description__c);
          }catch(e) {
            console.log("error:pages");
          }finally{
            console.log("画像データ取得：", item);
          }
          return ret;
        });
      }
      else if (result === '20700') {
        // 申込詳細取得失敗
        const dialog = {
          type: 'ok', // '閉じる'のみ表示
          title: '',
          message: 'workConsideration.dialog.error.failure',
          action: this.onClickBack
        };
        doOpenDialog(dialog);
      }
      else {
        // その他エラー
        const dialog = {
          type: 'error', // '閉じる'のみ表示
          title: 'system.message.error.title',
          message: 'system.message.error.context',
        };
        doOpenDialog(dialog);
      }

    }
    catch (err) {
      console.log(`エラー: ${err}`);
      // その他エラー
      const dialog = {
        type: 'error', // '閉じる'のみ表示
        title: 'system.message.error.title',
        message: 'system.message.error.context',
      };
      doOpenDialog(dialog);
    }

  };

  render() {
    const { classes, intl, applyDetail, finalImage } = this.props;

    const selKind1 = intl.formatMessage({ id: 'workConsideration.select.architecture' });
    const selKind3 = intl.formatMessage({ id: 'workConsideration.select.civilEngineering' });
    const selKind7 = intl.formatMessage({ id: 'workRequest.select.communicationLineEngineering' });
    const selKind8 = intl.formatMessage({ id: 'workConsideration.select.workOther' });

    let applyData = [];
    let guidMessageID = '';
    let isEstimateBtnDisable = true;
    let isBillBtnDisable = true;
    let isConsentBtnDisable = true;
    let isRemovalBtnDisable = true;
    
    if (applyDetail) {
      if (applyDetail.errorCode === '00000') {
        // 申込詳細の取得
        if (applyDetail.data) {
          applyData = applyDetail.data;
        }
        // 添付資料の取得
        if (applyDetail.data.Attachment) {
          attachmentFiles = applyDetail.data.Attachment;
        }
      }
      else if (applyDetail.errorCode === '20700' || applyDetail.errorCode === '20701') {
        // 詳細取得エラーだった場合(申込メニュー画面へ遷移)
        const { doOpenDialog } = this.props;
        const dialog = {
          type: 'ok', // '閉じる'のみ表示
          title: '',
          message: 'workConsideration.dialog.error.failure',
          action: this.onClickBack
        };
        doOpenDialog(dialog);
      } else {
        // その他エラー(ログイン画面へ遷移)
        const { doOpenDialog } = this.props;
        const dialog = {
          type: 'error', // '閉じる'のみ表示
          title: 'system.message.error.title',
          message: 'system.message.error.context',
        };
        doOpenDialog(dialog);
      }
    }

    if (applyDetail) {
      // メッセージ切り替え
      if (applyData.Status__c === "撤去可否登録～撤去工事検査" && applyData.RemoveProperty__c === "否") {
        // 撤去確認待
        guidMessageID = 'workConsideration.message.removalConfirm';
      } else if ( !applyData.FreeOfChargeFlag__c ) {
          if (applyData.Status__c === "承諾入力～取付工事検査" && applyData.AttachApprovalInput__c === "未") {
            // 有償 見積金額確認待
            guidMessageID = 'workConsideration.message.estimateConfirm';
          } else if (applyData.Status__c === "精算" && applyData.AttachWork.PaymentAcceptance__c === "未") {
            // 有償 請求金額確認待
            guidMessageID = 'workConsideration.message.billConfirm';
          }
      } else {
        if (applyData.Status__c === "承諾入力～取付工事検査" && applyData.AttachApprovalInput__c === "未") {
          // 無償 承諾待
          guidMessageID = 'workConsideration.message.consent';
        }
      }

      // ボタン活性非活性切り替え
      if (applyData.Status__c === "撤去可否登録～撤去工事検査" && applyData.RemoveProperty__c === "否") {
        isRemovalBtnDisable = false;
      }
      if (!applyData.UnnecessaryEstimate__c
          && (applyData.Status__c === "承諾入力～取付工事検査"
            || applyData.Status__c === "精算"
            || applyData.Status__c === "撤去可否登録～撤去工事検査"
            || applyData.Status__c === "完了")) {
        isEstimateBtnDisable = false;
      }
      if ((!applyData.BillingUnnesessary__c || applyData.CancelChargeRequest__c)
          && (applyData.Status__c === "精算"
            || applyData.Status__c === "撤去可否登録～撤去工事検査"
            || applyData.Status__c === "完了")) {
        isBillBtnDisable = false;
      }
      if (applyData.Status__c === "承諾入力～取付工事検査" && applyData.AttachApprovalInput__c === "未") {
        isConsentBtnDisable = false;
      }
    }

    return (
      <div className={classes.root}>
      <form noValidate autoComplete="off" className={classes.root}>
      <UserHeader />

        <Typography variant="h5" className={classes.typography2}>件名：{applyData.OrderName__c}</Typography>
        <Typography variant="subtitle1" className={classes.typographyImg}><FormattedMessage id={'workConsideration.title.latestImage'}/></Typography>
        <div style={{margin:"0 0 20px 10px"}}>
        <Grid container>

{/* 最終画像 */}
        <Grid item xs={8}>
        {finalImage && finalImage.length > 0 ?
          <Card className={classes.cardimage}>
            {finalImage.map((item, index) => (
            <div key={index} >
              {(item.ImageBody && item.ImageBody === "ERROR") &&
                <div className={classes.circle}>
                <hr size="0.5" margin="0px"/>
                <img src="" className={classes.media} alt="画像の読込みに失敗しました"/>
                </div>
              }
              {(item.ImageBody && item.ImageBody !== "ERROR") &&
                <img src={item.ImageBody} className={classes.media} alt=""/>
              }
              {!(item.ImageBody) &&
                <div className={classes.circle}>
                  {(index>0) &&
                    <hr />
                  }
                  <CircularProgress/>
                </div>
              }
              <CardContent className={classes.cardContent}>
                <Typography className={classes.typographyDescription} variant="body2" color="textSecondary" component="p">
                  {item.Description__c ? item.Description__c : "（説明の登録がありません）"}
                </Typography>
              </CardContent>
            </div>
            ))}
          </Card>
          :
          <Card className={classes.cardimage}>
          <CardContent>
            <FormattedMessage id={'workConsideration.message.nodata'} />
          </CardContent>
          </Card>
        }
        </Grid>
        <Grid item xs={4}>
          <Button
            variant="contained"
            color="primary"
            className={classes.buttonS}
            size="small"
            onClick={this.onClickRequest}
            disabled={ (((this.props.finalImage) ? this.props.finalImage.length : 0) !== ((applyData.ImageDatas) ? applyData.ImageDatas.length : 0)) ? true : false }
          >
            <span><FormattedMessage id={'workConsideration.btn.updates'}/></span>
          </Button>
        </Grid>
        </Grid>
        </div>

{/* 郵便番号 */}
         <TextField
            id="Postalcode__c"
            name="Postalcode__c"
            label={<FormattedMessage id='workRequest.in.zipcode'/>}
            value={applyData.Postalcode__c ? applyData.Postalcode__c : ""}
            className={classes.textFieldS3}
            margin="normal"
            InputProps = {{
                readOnly: true
            }}
            variant="outlined"
          />

{/* 現場所在地(住所) */}
      <Grid container>
        <TextField
          id="WorkSiteAddress__c"
          name="WorkSiteAddress__c"
          label={<FormattedMessage id='workConsideration.in.workaddress'/>}
          className={classes.textFieldL}
          value={applyData.WorkSiteAddress__c ? applyData.WorkSiteAddress__c : ''}
          margin="normal"
          style={{ width: "100%" }}
          InputProps = {{
            readOnly: true
          }}
          variant="outlined"
        />
      </Grid>

{/* 現場所在地(電柱番号) */}
        <TextField
          id="WorkSitePoleNo__c"
          name="WorkSitePoleNo__c"
          label={<FormattedMessage id='workConsideration.in.poleNumber'/>}
          className={classes.textFieldS}
          style={{ width: "200px" }}
          value={applyData.WorkSitePoleNo__c ? applyData.WorkSitePoleNo__c: ''}
          margin="normal"
          InputProps = {{
            readOnly: true
          }}
          variant="outlined"
        />

{/* 取付希望期間 */}
        <Typography variant="subtitle1" className={classes.typography3}>
          <FormattedMessage id={'workConsideration.title.term'}/><font size="2">（※取付期間が１年以上の場合は、標準金額に対して追加料金が発生します。）</font>
        </Typography>
        <p style={{fontSize: 5, height: 1}}></p>        
        <Grid container>
          <TextField
            id="StartRequireAttachTerm__c"
            className={classes.textFieldDate}
            label="取付を希望される日"
            value={applyData.StartRequireAttachTerm__c ? m(applyData.StartRequireAttachTerm__c).format("YYYY/MM/DD") : ""}
            margin="normal"
            variant="outlined"
            InputLabelProps={{
              shrink: true,
            }}
          />
          <Typography className={classes.dateMark}>～</Typography>
          <TextField
            id="EndRequireAttachTerm__c"
            className={classes.textFieldDate}
            label="防護管が不要となる日"
            value={applyData.EndRequireAttachTerm__c ? m(applyData.EndRequireAttachTerm__c).format("YYYY/MM/DD") : ""}
            margin="normal"
            variant="outlined"
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>

{/* 工事・作業の分類 */}
        <div style={{marginTop:"10px"}}>
          <FormControl component="fieldset" className={classes.formControl}>
            <FormLabel component="legend" className={classes.formLabel}><FormattedMessage id={'workConsideration.title.worktype'}/></FormLabel>
            <div style={{paddingLeft:"1px", width:"780px"}}>
              <p style={{fontSize: 5, height: 2}}></p>
              <RadioGroup name="Purpose__c" id="Purpose__c" row>
              <Grid container >
              <Grid item xs={12} md={2}>
                <FormControlLabel value={selKind1} control={<RadioB checked={applyData.Purpose__c === selKind1 ? true : false} />} label={<FormattedMessage id='workConsideration.select.architecture'/>} />
                </Grid>
                <Grid item xs={12} md={3}>
                <FormControlLabel value={selKind3} control={<RadioB checked={applyData.Purpose__c === selKind3 ? true : false} />} label={<FormattedMessage id='workConsideration.select.civilEngineering'/>} />
                </Grid>
                <Grid item xs={12} md={2}>
                <FormControlLabel value={selKind7} control={<RadioB checked={applyData.Purpose__c === selKind7 ? true : false} />} label={<FormattedMessage id='workConsideration.select.communicationLineEngineering'/>} />
                </Grid>
                <Grid item xs={12} md={2}>
                <FormControlLabel value={selKind8} control={<RadioB checked={applyData.Purpose__c === selKind8 ? true : false} />} label={<FormattedMessage id='workConsideration.select.workOther'/>} />
                </Grid>
              </Grid>
              </RadioGroup>
            </div>
          </FormControl>
        </div>

        {(applyData.Purpose__c === selKind8) &&
          <TextField
            id="PurposeOther__c"
            name="PurposeOther__c"
            label={<FormattedMessage id='workConsideration.select.workOther.memo'/>}
            className={classes.textFieldS}
            value={applyData.PurposeOther__c ? applyData.PurposeOther__c : ''}
            margin="normal"
            InputProps = {{
              readOnly: true
            }}
            variant="outlined"
          />
        }

        <p style={{fontSize: 5, height: 5}}></p> 
        <Typography variant="subtitle1" className={classes.typography3}>添付資料</Typography>
        
        <p style={{fontSize: 5, height: 2}}></p>
          <Typography variant="body2" className={classes.typographyValue} style={{paddingLeft:"20px"}}>
          {attachmentFiles.map((item) => (
            <>
            ・<u style={{color:'#0000ff', cursor:'hand'}}>
                  <a target="_blank" rel="noopener noreferrer" href="true" onClick={this.onDownloadFile}>
                    {item.Name.replace("資料_", "")}
                  </a>
              </u>
              <br></br>
            </>
          ))}
          </Typography>
        <p></p>

      {/* 取付資材数量 グリッド入力を挿入予定 */}
        <Typography variant="subtitle1" className={classes.typography3}>取付希望数</Typography>
        <p style={{fontSize: 5, height: 1}}></p>
            <Grid container spacing={1} XS={12} sm={8} md={6}>
              <Grid container xs={6} md={3} className={classes.containerGridItem}>
                <TextField
                  id="HighVolVolume__c"
                  name="HighVolVolume__c"
                  label={<font size={2}>高圧線 単位</font>}
                  value={applyData.HighVolVolume__c ? applyData.HighVolVolume__c : ""}
                  margin="normal"
                  variant="outlined"
                  type="text"
                  multiline={false}
                  className={classes.fields4}
                  InputProps = {{
                    readOnly: true
                  }}
                />
              </Grid>
              <div style={{paddingLeft:'0px', width: '10px'}}>
              <Grid item xs={1} md={1} className={classes.container1}>
                <FormLabel component="legend" className={classes.formLabel2}><font size="2">単位</font></FormLabel>      
              </Grid>
              </div>
              <div style={{paddingLeft:'0px'}}>
                <FormGroup row></FormGroup>
                  <FormControlLabel
                    id="HighVolFraction__c"
                    name="HighVolFraction__c"
                    control={<Check checked={applyData.HighVolFraction__c ? true : false} />}
                    label=""
                    style={{visibility: "hidden"}}
                  />
              </div>              
              <Grid container xs={6} md={3} className={classes.containerGridItem}>          
                <TextField
                  id="LowVolVolume__c"
                  name="LowVolVolume__c"
                  label={<font size={2}>低圧線 単位</font>}
                  value={applyData.LowVolVolume__c ? applyData.LowVolVolume__c : ""}
                  margin="normal"
                  variant="outlined"
                  type="text"
                  multiline={false}
                  className={classes.fields4}
                  InputProps = {{
                    readOnly: true
                  }}
                />
              </Grid>
              <div style={{paddingLeft: '0px', width: '10px'}}>
              <Grid item xs={1} md={1} className={classes.container1}>
                <FormLabel component="legend" className={classes.formLabel2}><font size="2">単位</font></FormLabel>      
              </Grid>
              </div>
              <div style={{paddingLeft:'0px'}}>
                <FormGroup row>
                  <FormControlLabel
                    id="LowVolFraction__c"
                    name="LowVolFraction__c"
                    control={<Check checked={applyData.LowVolFraction__c ? true : false} />}
                    label=""
                    style={{visibility: "hidden"}}
                  />
                </FormGroup>
              </div>
            </Grid>
            <Grid container spacing={1} XS={12} sm={8} md={6}> 
              <Grid container xs={6} md={3} className={classes.containerGridItem}>
                <TextField
                  id="DropVolume__c"
                  name="DropVolume__c"
                  label={<font size={2}>引込線(単線/三線) 単位</font>}
                  value={applyData.DropVolume__c ? applyData.DropVolume__c : ""}
                  margin="normal"
                  variant="outlined"
                  type="text"
                  multiline={false}
                  className={classes.fields4}
                  InputProps = {{
                    readOnly: true
                  }}
                />  
              </Grid>
              <div style={{paddingLeft:'0px', width: '10px'}}>
              <Grid item xs={1} md={1} className={classes.container1}>
                <FormLabel component="legend" className={classes.formLabel2}><font size="2">単位</font></FormLabel>      
              </Grid>
              </div> 
              <div style={{paddingLeft:'0px'}}>
                <FormGroup row>
                  <FormControlLabel
                    id="DropVolFraction__c"
                    name="DropVolFraction__c"
                    control={<Check checked={applyData.DropVolFraction__c ? true : false} />}
                    label=""
                    style={{visibility: "hidden"}}
                  />
                </FormGroup>
              </div>           
              <Grid container xs={6} md={3} className={classes.containerGridItem}>     
                <TextField
                  id="ComVolume__c"
                  name="ComVolume__c"
                  label={<font size={2}>引込線(三線) 単位</font>}
                  value={applyData.ComVolume__c ? applyData.ComVolume__c : ""}
                  margin="normal"
                  variant="outlined"
                  type="text"
                  multiline={false}
                  className={classes.fields4}
                  InputProps = {{
                    readOnly: true
                  }}
                />
              </Grid>
              <div style={{paddingLeft:'0px', width: '10px'}}>
              <Grid item xs={1} md={1} className={classes.container1}>
                <FormLabel component="legend" className={classes.formLabel2}><font size="2">単位</font></FormLabel>      
              </Grid>
              </div>
              <div style={{paddingLeft:'0px'}}>
                <FormGroup row>
                  <FormControlLabel
                    id="ComVolFraction__c"
                    name="ComVolFraction__c"
                    control={<Check checked={applyData.ComVolFraction__c ? true : false} />}
                    label=""
                    style={{visibility: "hidden"}}
                  />
                </FormGroup>
              </div>
            </Grid>
            <Grid container spacing={1} XS={12} sm={8} md={6}>
              <Grid container xs={6} md={3}>
                <TextField
                  id="TransOpenVolime__c"
                  name="TransOpenVolime__c"
                  label={<font size="2">変圧器・開閉器 個数</font>}
                  value={applyData.TransOpenVolime__c ? applyData.TransOpenVolime__c : ""}
                  margin="normal"
                  variant="outlined"
                  type="text"
                  multiline={false}
                  className={classes.fields4}
                  InputProps = {{
                    readOnly: true
                  }}
                />
              </Grid>
              <div style={{paddingLeft:'0px', width: '10px'}}>
              <Grid item xs={1} md={1} className={classes.container1}>
                <FormLabel component="legend" className={classes.formLabel2}><font size="2">個</font></FormLabel>      
              </Grid>
              </div>
            </Grid>

{/* ご連絡事項 */}
        <TextField
          id="Message__c"
          name="Message__c"
          label={<FormattedMessage id='workConsideration.in.memo'/>}
          className={classes.textFieldL}
          value={applyData.Message__c ? applyData.Message__c : ''}
          margin="normal"
          variant="outlined"
          InputProps = {{
            readOnly: true
          }}
          multiline={true}
          rows={3}
        />

{/* 取付予定日 */}
        <TextField
          id="AttachWorkSchedule__c"
          name="AttachWorkSchedule__c"
          label={<FormattedMessage id='workConsideration.schedule.construct'/>}
          className={classes.textFieldS}          
          value={applyData.AttachWorkSchedule__c ? m(applyData.AttachWorkSchedule__c).format("YYYY/MM/DD") : ""}
          margin="normal"
          variant="outlined"
          InputLabelProps={{
            shrink: true,
          }}
        />

{/* 撤去予定日 */}
        <TextField
          id="RemvScheduleDate__c"
          name="RemvScheduleDate__c"
          label={<FormattedMessage id='workConsideration.schedule.removal'/>}
          className={classes.textFieldS}
          value={applyData.RemoveScheduleDate__c ? m(applyData.RemoveScheduleDate__c).format("YYYY/MM/DD") : ""}
          margin="normal"
          variant="outlined"
          InputLabelProps={{
            shrink: true,
          }}
        />

        <div style={{margin: "20px 0 15px 0"}}>
        {guidMessageID &&
          <Typography align="center"><font size="3"><FormattedMessage id={guidMessageID}/></font></Typography>
        }
        </div>
        {/* 現場立会有りの場合メッセージを表示 */}
        {(applyData && applyData.StartRequireAttachTerm__c && applyData.EndRequireAttachTerm__c &&
          common.getTermDays(applyData.StartRequireAttachTerm__c, applyData.EndRequireAttachTerm__c) >= 365) &&
          <Typography variant="caption" display="inline" className={classes.typographyWarn}>
            取付期間が１年以上のため追加料金が発生します。
          </Typography>
        }
        {/* 現場立会有りの場合メッセージを表示 */}
        {(applyData && applyData.Witness__c === '有') &&
          <Typography variant="caption" display="inline" className={classes.typographyWarn}>
            現場立合費用が発生します。
          </Typography>
        }
        <p></p>
        <Grid container>
          <Grid item xs={2}></Grid>
          <Grid item xs={8}>
            <Grid container spacing={8}>
              {!applyData.FreeOfChargeFlag__c &&
                <React.Fragment>
                  <Grid item xs={12}>
                    {/* お見積金額確認ボタン */}
                    <Button
                      variant="contained"
                      color="primary"
                      className={classes.button}
                      size="large"
                      onClick={this.onClickEstimateConfirm}
                      disabled={isEstimateBtnDisable}
                    >
                    <span><FormattedMessage id={'workConsideration.btn.estimateConfirm'}/></span>
                    </Button>
                  </Grid>
                  <Grid item xs={12}>
                    {/* ご請求金額確認ボタン */}
                    <Button
                      variant="contained"
                      color="primary"
                      className={classes.button}
                      size="large"
                      onClick={this.onClickBillConfirm}
                      disabled={ isBillBtnDisable }
                    >
                    <span><FormattedMessage id={'workConsideration.btn.billConfirm'}/></span>
                    </Button>
                  </Grid>
                </React.Fragment>
              }
              {applyData.FreeOfChargeFlag__c &&
                <Grid item xs={12}>
                  {/* 承諾ボタン */}
                  <Button
                    variant="contained"
                    color="primary"
                    className={classes.button}
                    size="large"
                    onClick={this.onClickConsent}
                    disabled={isConsentBtnDisable}
                  >
                  <span><FormattedMessage id={'workConsideration.btn.consent'}/></span>
                  </Button>
                </Grid>
              }
              <Grid item xs={12} sm={6}>
                {/* 問合せ・写真追加ボタン */}
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.button}
                  size="large"
                  onClick={this.onClickInquiry}
                >
                  <span><FormattedMessage id={'workConsideration.btn.inqualy.add'}/></span>
                </Button>
              </Grid>
              <Grid item xs={12} sm={6}>
                {/* 撤去依頼ボタン */}
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.button}
                  size="large"
                  onClick={this.onClickRemoval}
                  disabled={isRemovalBtnDisable}
                >
                  <span><FormattedMessage id={'workConsideration.btn.confirm'}/></span>
                </Button>
              </Grid>
              <Grid item xs={12}>
                {/* 戻るボタン */}
                <Button
                  variant="outlined"
                  color="primary"
                  className={classes.button}
                  size="large"
                  onClick={this.onClickBack}
                >
                  <span><FormattedMessage id={'common.btn.back'}/></span>
                </Button>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={2}></Grid>
        </Grid>
      </form>
      </div>
    );
  }
}

const FORM_NAME = "WorkConsiderration";

WorkConsider.propTypes = {
  classes: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
};

WorkConsider = reduxForm({
  form: FORM_NAME,
  destroyOnUnmount: false,
})(connect(state => {
  return {
    values: getFormValues(FORM_NAME)(state),
  };
})(WorkConsider));


export default withStyles(styles)(
  connect( )(injectIntl(WorkConsider))
);
